import { IoMdFootball } from "react-icons/io";

function Spinner() {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center  bg-opacity-30 backdrop-blur-md z-50">
      <IoMdFootball className="text-5xl text-[#6ca87e] animate-bounce-slow" />
    </div>
  );
}

export default Spinner;
